import {Search} from 'platform/components';

import {KeyboardEvent, useState} from 'react';

import i18n from '@dms/i18n';

import {SearchContainer} from './styles';

export type SearchRowProps = {
  onSearch: (search: string) => void;
};

export const SearchRow = (props: SearchRowProps) => {
  const [searchValue, setSearchValue] = useState<string>('');

  const handleKeyDown = (e: KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      props.onSearch(searchValue);
    }
  };

  const handleClear = () => {
    setSearchValue('');
    props.onSearch('');
  };

  return (
    <SearchContainer>
      <Search
        placeholder={i18n.t('general.labels.searchPlaceholder')}
        value={searchValue}
        onChange={(newValue) => setSearchValue(newValue ?? '')}
        onKeyDown={handleKeyDown}
        onClear={handleClear}
      />
    </SearchContainer>
  );
};
